import type { FC } from 'react';
import React from 'react';
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports
import { Subscribe } from 'unstated';

import { DialogsStateContainer } from './DialogsStateContainer.tsx';
import { DialogsComponent } from './DialogsComponent.tsx';
import { useDialogsState } from './useDialogs.ts';

export const Dialogs: FC = (props) => {
	const { state } = useDialogsState();
	return (
		<Subscribe to={[DialogsStateContainer]}>
			{(dialogs: DialogsStateContainer) => {
				/**
				 * Keep the order of the dialogs by key so we can use unstated dialogs
				 * along side react-sweet-state dialogs. We should expect each array to be
				 * sorted in ascending order by key and we can optimize the merging strategy to linear time.
				 * However, in practice we shouldn't expect the number of active dialogs to be greater than single digits
				 * */
				const stack = [...dialogs.state.stack, ...state.stack].sort((a, b) => a.key - b.key);

				return <DialogsComponent stack={stack} {...props} />;
			}}
		</Subscribe>
	);
};
